<template>
    <div id="app" class="pmc">
        <div id="wrap">
            <div class="main">
                <modal v-show="showTokenExpiring" :closeInHeader="false" @close="close" ref="modal">
                    <template v-slot:body>
                        <token-expiring></token-expiring>
                    </template>
                </modal>

                <modal v-show="userIdle" :closeInHeader="false" ref="idleModal">
                    <template v-slot:body="{dialogOpen}">
                        <idle :duration="duration" :dialogOpen="dialogOpen"></idle>
                        <div class="row" id="idle-footer">
                            <div class="col-8 col-sm-9 p-0">
                                <button class="btn btn-primary pmbtn" @click="resume">Resume</button>
                            </div>
                            <div class="col-4 col-sm-3 text-sm-end text-start p-0 pt-sm-2">
                                <a href="//secure.pultemortgage.com//MyAccount/Home/LogOff/">Log out</a>
                            </div>
                        </div>
                    </template>
                </modal>

                  
                  <nav-bar :class="{ 'hide-navbar': hideLinks }" :hideLinks="hideLinks" :topMargin="topMargin" ref="navbar" :scrolled="scrolled" :authenticated="isAuthenticated" authenticatedHome="//secure.pultemortgage.com/Dashboard/Home" :navLinks="navLinks">
                    <login-form :hideInfoTooltip="true" ref="loginForm"></login-form>
                    <template v-slot:userContextMenu>
                        <user-menu></user-menu>
                    </template>
                  </nav-bar>
                
                <transition name="alertBar-slide">
                    <alert-bar v-if="showBanner"
                               :message="bannerText"
                               :linkText="specialMessagingLinkText"
                               textColor="#ffffff"
                               backgroundColor="#075A77">
                    </alert-bar>
                </transition>

                <!--<transition name="lfade" @after-leave="afterLeave">-->
                <router-view></router-view>
                <!--</transition>-->



                <pulte-footer id="myloan-footer"
                              :familyOfBrandLinks="familyOfBrandLinks"
                              :copyrightLinks="copyrightLinks"
                              :siteLinks="footerLinks"
                              :careerLinks="careerLinks"
                              equalHousingLink="/equal-housing-lender"
                              v-show="showFooter"></pulte-footer>
            </div>
        </div>   
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex';
    import TokenExpiring from './components/modals/content/TokenExpiring';
    import UserMenu from './components/sections/nav/UserContextDropdownMenu';
    import {Idle} from '@pulte/pulte-myloan-npm'; 
    //import '@pulte/pulte-myloan-npm/dist/pulteidlenotification.css';
    import AlertBar from './components/AlertBar.vue';
    import siteApi from './api/siteApi';

    export default {
        name: "home",
        components: {            
            'user-menu': UserMenu,
            'token-expiring': TokenExpiring,
            'idle' : Idle,
            'alert-bar': AlertBar,
        },
        data() {
            return {
                scrolled: false,
                showTokenExpiring: false,
                userIdle: false,
                enableOutageMessaging: false,
                bannerText: '', 
            };
        },
        watch: {
            '$route'(to, from) {
                if (this.$refs.navbar.$refs.loginForm && to.name !== 'registrationcomplete') {
                    this.$refs.navbar.$refs.loginForm.clearLoginMessage();
                }
                this.scrolled = this.$route.name === 'home' ? window.pageYOffset > 0 : true;               


                if (this.$refs.navbar.isMenuVisible || this.$refs.navbar.isMobileMenuVisible && to.name !== 'registrationcomplete') {
                    this.$refs.navbar.toggleAll();  // note: only toggles if visible
                }
                else if (to.name === 'registrationcomplete') {
                    this.$nextTick(() => {
                      this.$refs.navbar.doLoginMessageDropdown()
                    });
                }
            }
        },
        methods: {
            ...mapActions(['initializeAuth']),
            ...mapMutations(['setReturnUrl', 'toggleFooter']),
            scroll() {
                var isScrolled = this.$route.name === 'home' ? window.pageYOffset > 0 : true;
                this.scrolled = isScrolled;
            },
            afterLeave() {
                this.$root.$emit('triggerScroll')
            },
            close() {
                this.showTokenExpiring = false;
                this.$refs.modal.close();
            },
            resume() {
                this.userIdle = false;
                this.$refs.idleModal.close();
            }
        },
        computed: {
            ...mapGetters(['familyOfBrandLinks',
                'copyrightLinks',
                'careerLinks',
                'footerLinks',
                'defaultReturnUrl',
                'returnUrl',
                'showFooter',
                'navLinks',
                'isAuthenticated'
            ]),
            hasSpecialMessaging() {
              return this.enableOutageMessaging;
            },
            showBanner() {
                console.log("this route: ", this.$route, "hasSpecialMessaging: ", this.hasSpecialMessaging)
                return this.$route.name === 'home' && this.hasSpecialMessaging
            },
            topMargin() {
              if (this.showBanner) {
                return '60px';
              }
              return '0';
            },
            specialMessagingLinkText() {
              var specialMessagingLinkText = [];
              return specialMessagingLinkText;
            },
            computedNavLinks() {
              return this.hideLinks ? [] : this.navLinks;
            },
            hideLinks() {
              return this.$route.name === null || ['tho'].includes(this.$route.name);
            },
            duration() {
                return window.idleTimer / 1000;
            },
            navbar() {
                return this.$el.getElementsByClassName('navbar')[0];
            }
        },
        created() {
            window.addEventListener('scroll', this.scroll);
            this.scroll();
            
            this.$bus.$on('tokenExpiring', () => {
                this.showTokenExpiring = true;
            });
        },
        onIdle() {
            if (this.isAuthenticated) {
                this.userIdle = true;
                this.$refs.idleModal.show();
            }
        },
        async mounted() {
            var self = this;
            console.log(`app: diagnostic info: current time ${new Date()}`);
            const result = await siteApi.getClientSettings(this.$config.identityApiBaseUrl);
            const enableBanner =  result?.data?.enableBanner;
            const bannerText = result?.data?.bannerText;
            console.log(`app: diagnostic info: client settings result: ${JSON.stringify(result)}`); 
            // store return url in the vuex store if we've got a return url in our querystring
            var returnUrl = self.defaultReturnUrl;
            if (self.$route.query.ReturnUrl) {
                returnUrl = self.$route.query.ReturnUrl;
            }
            console.log('app: setting return url: ' + returnUrl);
            this.setReturnUrl(returnUrl);

            this.$store.subscribe((mutation, state) => {
                switch (mutation.type) {
                    case 'setReturnUrl':                        
                        if (self.$route.name === 'registrationcomplete' || ((self.returnUrl !== null && self.returnUrl !== undefined && self.returnUrl !== '') && self.returnUrl !== self.defaultReturnUrl)) {
                            console.log('app: setReturnUrl mutation callback triggered: ' + self.returnUrl);
                            this.$refs.navbar.doLoginMessageDropdown().then(() => {
                                try {
                                    // should this be this.$refs.navbar.$refs.loginForm
                                    // setTimeout(this.$refs.loginForm.displayLoginMessage(), 1000);
                                    this.$refs.navbar.$refs.loginForm.doLoginMessageDropdown();
                                }
                                catch {
                                    console.log('registration complete error on line 190');
                                }
                           });
                         }
                        break;
                }
            });
            this.enableOutageMessaging = enableBanner
            this.bannerText = bannerText;
        },
        unmounted() {
            window.removeEventListener('scroll', this.scroll);
        }
    };
</script>

<style lang="scss">
  .grecaptcha-badge {
      visibility: hidden;
      display:none;
  }

  .lfade-enter-active, .lfade-leave-active {
      transition-property: opacity;
      transition-duration: 0.75s;
  }

  .lfade-enter-active {
      transition-delay: 0.75s;
  }

  .lfade-enter, .lfade-leave-active {
      opacity: 0
  }
  
  .v-lazy-image {
      filter: blur(10px);
      transition: filter 0.7s;
  }

  .v-lazy-image-loaded {
      filter: blur(0);
  }
  .alertBar-slide-enter-active, .alertBar-slide-leave-active {
      transition: all .35s ease-in;
  }

  .alertBar-slide-enter, .alertBar-slide-leave-to {
      transform: translateY(-65px);
  }
  
  .alertBar-slide-enter-to, .alertBar-slide-leave {
      transform: translateY(0);
  }

  .hide-navbar #navBarContent[style*="display: none"] {
    display: none !important;
  }

</style>